import { Component, Input, OnInit } from '@angular/core';
import { TransitionsActions } from '../../../application-state/store/actions';
import { Observable } from 'rxjs';
import { Order } from '../../../orders/models';
import { PotentialAction } from '../../models';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../../../application-state/store';
import { filter, takeUntil } from 'rxjs/operators';
import { BaseOnDestroyComponent } from '../../injectables/BaseOnDestroy.component';
import { ActionBoxInputTypes } from '../../models/action-box-input-types.type';
import { AuthService } from '../../../auth/services/auth.service';

@Component({
  selector: 'app-action-box-final-invoice-needed',
  styleUrls: ['./action-box-final-invoice-needed.component.scss'],
  template: `
    <div class="action-box">
      <div class="action-required-label" *ngIf="canMakeTransition">
        Aktion erforderlich
      </div>
      <div class="action-required-label bg-green" *ngIf="!canMakeTransition">
        Warte auf Zuarbeit
      </div>
      <div class="content ">
        <div class="row" *ngIf="canMakeTransition">
          <div class=" col-auto my-2 align-items-center">
            <div class="row ">
              <div class=" col-auto header">
                Auftrag abgebrochen - Rechnung notwendig?
              </div>
              <div class="sub-header col-auto">
                Bitte prüfen, ob eine Rechnung nach dem Auftragsabbruch nötig
                ist!
              </div>
            </div>
          </div>
          <div class="actions col my-2 text-right">
            <button
              class="decision-btn btn-wider me-3"
              mat-button
              color="green"
              (click)="handleMakeTransition()"
              [disabled]="!okAction"
            >
              <mat-icon class="me-2">done</mat-icon>
              <span>Rechnung nötig</span>
            </button>
            <button
              class="decision-btn btn-wider me-3"
              mat-button
              color="green"
              (click)="handleMakeTransition2()"
              [disabled]="!nokAction"
            >
              <mat-icon class="me-2">cancel</mat-icon>
              <span>keine Rechnung nötig</span>
            </button>
          </div>
        </div>
        <div class="row " *ngIf="!canMakeTransition">
          <div class=" col-auto header">
            Rechnungslegung nach Abbruch prüfen
          </div>
          <div class="sub-header col-auto">
            Warte auf Entscheidung ob nach dem Abbruch eine Rechnung benötigt
            wird
          </div>
        </div>
      </div>
      <!--      <div class="additional-content p-4" *ngIf="canMakeTransition">-->
      <!--      </div>-->
    </div>
  `
})
export class ActionBoxFinalInvoiceNeededComponent extends BaseOnDestroyComponent
  implements OnInit {
  @Input() order$: Observable<Order>;
  @Input() inputType: ActionBoxInputTypes;

  order: Order;
  okAction: PotentialAction = null;
  nokAction: PotentialAction = null;

  constructor(
    private store$: Store<ApplicationState>,
    private authService: AuthService
  ) {
    super();
  }

  get canMakeTransition(): boolean {
    return (
      this.authService.isSales() ||
      this.authService.isAccounting() ||
      this.authService.isAdmin() ||
      this.authService.isSupervisor() ||
      false
    );
  }

  ngOnInit(): void {
    this.order$
      .pipe(
        takeUntil(this.onDestroy$),
        filter(order => !!order)
      )
      .subscribe(order => {
        this.order = order;
        this.okAction = order.potentialActions?.find(
          e =>
            e.transition.indexOf('no_order_to_create_final_invoice') > -1 &&
            !e.error
        );
        this.nokAction = order.potentialActions?.find(
          e =>
            e.transition.indexOf(
              'no_order_to_check_return_shipment_necessary'
            ) > -1 && !e.error
        );
      });
  }

  handleMakeTransition(): void {
    const action = this.okAction;
    if (!action) {
      return;
    }
    const uri = `${this.order['@id']}/transitions?workflow=${action.workflow}&transition=${action.transition}`;
    const payload = {
      workflow: action.workflow,
      transition: action.transition
    };
    this.store$.dispatch(TransitionsActions.MakeTransition({ uri, payload }));
  }

  handleMakeTransition2(): void {
    const action = this.nokAction;
    if (!action) {
      return;
    }
    const uri = `${this.order['@id']}/transitions?workflow=${action.workflow}&transition=${action.transition}`;
    const payload = {
      workflow: action.workflow,
      transition: action.transition
    };
    this.store$.dispatch(TransitionsActions.MakeTransition({ uri, payload }));
  }
}
